import React from "react";

interface InputProps {
  id: string;
  type: string;
  value: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  errorMessage?: string;
  icon?: React.ReactNode;
  onIconClick?: () => void;
  inputClassName?: string;
  iconClassName?: string;
  wrapperClassName?: string;
  readOnly?: boolean;
  required?: boolean;
}

export const Input = ({
  id,
  type,
  value,
  placeholder,
  onChange,
  onBlur,
  errorMessage,
  icon,
  onIconClick,
  inputClassName,
  iconClassName,
  wrapperClassName,
  readOnly,
  required,
}: InputProps) => {
  return (
    <div className={`relative ${wrapperClassName ?? ""}`}>
      <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        required={required}
        onBlur={onBlur}
        className={`peer w-full h-11 px-4 py-2 border border-gray-200 focus:border-ominimo-400 focus:border-2 focus:outline-none bg-ghost-110 text-black placeholder-shown:text-gray-400 hover:bg-white font-normal text-[16px] leading-[22.4px] tracking-[0.2px] rounded-md ${
          errorMessage ? "border-red-500" : ""
        } ${inputClassName ?? ""}`}
        placeholder={placeholder}
      />
      {icon && (
        <button
          type="button"
          onClick={onIconClick}
          tabIndex={-1}
          className={`absolute right-3 top-4 text-gray-600 focus:outline-none ${iconClassName ?? ""}`}>
          {icon}
        </button>
      )}
      {errorMessage && <p className="text-red-500 text-sm mt-1">{errorMessage}</p>}
    </div>
  );
};
